module.exports = __webpack_public_path__ + "static/media/choose_us_2.2aa51341.png";